import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationInfo, AuthenticationInfoService, SessionInfo} from './authentication-info.service';
import {AppConstants} from './AppConstants';

@Injectable()
export class NotWithoutSessionGuardService implements CanActivate {
  constructor(
    private authnInfoService: AuthenticationInfoService,
    private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve: any) => {
      const t = this.authnInfoService.fetchAuthenticationInfo(undefined, (a: AuthenticationInfo, sessnInfo: SessionInfo) => {
        let retVal;
        let qp;
        if (state.url !== AppConstants.PATH_HOME &&
            state.url !== AppConstants.PATH_PROFILE) {
          qp = { next: state.url};
        }
        // if no tasks are in progress, continue forward
        if (!sessnInfo.hasSession || !sessnInfo.fullyAuthenticated || !sessnInfo.optionalsHandled) {
          this.router.navigate([AppConstants.ROUTE_LOGIN], {replaceUrl: true, queryParams: qp});
          retVal = false;
        } else {
          retVal = true;
        }
        resolve(retVal);
      });
    });
  }
}
